import React from 'react';
import './header.css' 
import { Dropdown } from 'react-bootstrap';

// Header.js - just use the new props directly
const Header = ({ 
  onPrintTables, 
  onLogout, 
  username, 
  onShowChangePassword,
  onSaveWorkspace,
  onResetWorkspace,
  onExportWorkspace,
  onImportWorkspace,
  isMarketController
}) => {

  return (
    <div className="app-header">
      <h5 className="app-title">Workstation</h5>

      <div className="header-username">
        {username && <span>Welcome, {username}</span>}
      </div>      

      <div className="dropdown header-dropdown">
        <Dropdown>
          <Dropdown.Toggle variant="secondary" id="dropdown-basic">
            Menu
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={onShowChangePassword}>Change Password</Dropdown.Item>
            
            <Dropdown.Divider />
            <Dropdown.Item onClick={onResetWorkspace}>Load Default Workspace</Dropdown.Item>
            <Dropdown.Item onClick={onSaveWorkspace}>Save Workspace</Dropdown.Item>
            <Dropdown.Item onClick={onExportWorkspace}>Save Workspace To Disk</Dropdown.Item>
            <Dropdown.Item onClick={onImportWorkspace}>Load Workspace From Disk</Dropdown.Item>
            <Dropdown.Divider />
            
            {/* 👇 Only show this if user is a market controller */}
            {isMarketController && (
              <>
                <Dropdown.Item onClick={onPrintTables}>Print Tables</Dropdown.Item>
                <Dropdown.Divider />
              </>
            )}
            <Dropdown.Divider />
            <Dropdown.Item onClick={onLogout}>Logoff</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default Header;
